"use client";

import React, { useCallback, useState } from "react";

import {
  UserEntity,
  useUserSearchConnections,
} from "@/src/hooks/api/generated";
import { useAuth } from "@/src/hooks/useAuth";

import { ChatBoxConversationPanel } from "./ChatBoxConversationPanel";
import { ChatBoxHeader } from "./ChatBoxHeader";
import { ChatBoxSuggestionList } from "./ChatBoxSuggestionList";
import { MessageComposer } from "./MessageComposer";

export function ChatBox(): JSX.Element {
  const { authData } = useAuth();
  const [isOpenSuggestion, setIsOpenSuggestion] = useState(false);
  const [suggestUsers, setSuggestUsers] = useState<UserEntity[]>([]);

  const {
    mutate: searchConnectionForChat,
    status: searchConnectionForChatStatus,
  } = useUserSearchConnections();

  const handleSearchConnection = useCallback(
    (searchTerm: string): void => {
      searchConnectionForChat(
        {
          data: {
            searchTerm,
          },
        },
        {
          onSuccess: (data) => {
            setSuggestUsers(data);
            setIsOpenSuggestion(true);
          },
        }
      );
    },
    [searchConnectionForChat]
  );

  return (
    <div className="flex flex-col w-[760px] border rounded-lg">
      {/* Chat box header component */}
      <ChatBoxHeader
        isLoading={searchConnectionForChatStatus === "pending"}
        onSearchTermChange={(text) => {
          handleSearchConnection(text);
        }}
      />
      {/* Conditional rendering based on chat data */}
      <ChatBoxSuggestionList
        isOpenSuggestion={isOpenSuggestion}
        handleIsOpenSuggestion={setIsOpenSuggestion}
        suggestUsers={suggestUsers}
        searchConnectionForChatStatus={searchConnectionForChatStatus}
      />

      {/* Chat box conversation panel component */}
      <ChatBoxConversationPanel />
      {/* Chat box composer component */}
      {!authData?.is_chat_blocked && <MessageComposer />}
    </div>
  );
}
